// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"4b011e72","84":"9adda54d","155":"a09e8720","213":"c79836de","239":"8e889764","247":"7d23990e","440":"47aa2339","455":"b79a996c","627":"cb7916a5","738":"32fdccc9","834":"e8cf2956","923":"28431a13"}[chunkId] + ".chunk.js";
};